exports = module.exports = require("../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asahi-background[data-v-3ec8d98a]{background-color:#fdd32a}.button-asahi[data-v-3ec8d98a]{font-size:8px}.active[data-v-3ec8d98a]{color:#fdd32a}.quick-menu-mobile div>a[data-v-3ec8d98a]{text-decoration:none}.quick-menu-mobile div>a>div[data-v-3ec8d98a]{font-size:12px}", ""]);

// exports
